module.exports = __webpack_public_path__ + "img/97faa55.jpg";